import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';

import Table from 'components/Table';
import { integrationsTable as TEXT } from 'locales/en/integration';
import IntegrationActions from './IntegrationActions';
import { DAY_MONTH, format } from 'utils/dateFormat';

const IntegrationsTable = ({ data, ...rest }) => {
  const [activeItem, setActiveItem] = useState(null);
  const toggleActiveItem = (id) => {
    if (activeItem === id) {
      setActiveItem(null);
    } else {
      setActiveItem(id);
    }
  };

  return (
    <Table
      titles={[TEXT.id, TEXT.name, TEXT.type, TEXT.createdBy, TEXT.date, '']}
      hasData={!!data.length}
      gridClassName="grid-5-cols"
      {...rest}
    >
      {data.map((item, idx) => {
        const dataIndexNumber = data.length - 1 === idx ? 'last' : idx;
        return (
          <Fragment key={item.id}>
            <span
              data-index-number={dataIndexNumber}
              className="text-javelin-gray-dark text-xs py-3 px-5"
            >
              {item.id}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className="text-javelin-gray-dark text-xs py-3 px-5"
            >
              {item.name}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className="text-javelin-gray-dark text-xs py-3 px-5"
            >
              {item.type}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className="text-javelin-gray-dark text-xs py-3 px-5"
            >
              {item.created_by}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className="text-javelin-gray-dark text-xs py-3 px-5"
            >
              {format(item.date, DAY_MONTH)}
            </span>
            <span
              data-index-number={dataIndexNumber}
              className="text-javelin-gray-dark text-xs relative py-3 text-right pr-5"
            >
              <IntegrationActions
                onClickOpen={() => toggleActiveItem(item.id)}
                isOpen={activeItem === item.id}
                onClose={() => setActiveItem(null)}
                id={item.id}
                position={idx <= data.length - 4 ? 'bottom' : 'top'}
              />
            </span>
          </Fragment>
        );
      })}
    </Table>
  );
};

IntegrationsTable.propTypes = {
  data: PropTypes.array,
};
IntegrationsTable.defaultProps = {
  data: [],
};
export default IntegrationsTable;
